import { render, staticRenderFns } from "./recallRegistrationList.vue?vue&type=template&id=1930aa25&scoped=true"
import script from "./recallRegistrationList.vue?vue&type=script&lang=js"
export * from "./recallRegistrationList.vue?vue&type=script&lang=js"
import style0 from "./recallRegistrationList.vue?vue&type=style&index=0&id=1930aa25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1930aa25",
  null
  
)

export default component.exports